import Navbar from "../../../components/Navbar/Navbar";
import DashboardToDisplay from "../components/DashboardToDisplay/DashboardToDisplay";

export default function Dashboard() {
    return (
        <>
            <Navbar />
            <div className="page">
                <DashboardToDisplay />
            </div>
        </>
    );
}
